import { CALENDAR_EVENT_SOURCE_IDS, type MarketCalendarEvent } from '../calendarEvents';

export interface CalendarPeriodSummary {
    busiestDate?: string;
    busiestEventCount: number;
    dividendCount: number;
    economicEventCount: number;
    highImpactEventCount: number;
    totalEventCount: number;
}

export const summarizeCalendarPeriod = (
    events: readonly MarketCalendarEvent[],
    from: string,
    to: string,
): CalendarPeriodSummary => {
    const periodEvents = events.filter((event) => event.date >= from && event.date <= to);
    const eventsByDate = periodEvents.reduce<Record<string, number>>((counts, event) => {
        counts[event.date] = (counts[event.date] ?? 0) + 1;
        return counts;
    }, {});
    const busiestEntry = Object.entries(eventsByDate).sort(
        ([leftDate, leftCount], [rightDate, rightCount]) => rightCount - leftCount || leftDate.localeCompare(rightDate),
    )[0];

    return {
        busiestDate: busiestEntry?.[0],
        busiestEventCount: busiestEntry?.[1] ?? 0,
        dividendCount: periodEvents.filter((event) => event.source === CALENDAR_EVENT_SOURCE_IDS.dividend).length,
        economicEventCount: periodEvents.filter((event) => event.source === CALENDAR_EVENT_SOURCE_IDS.economic).length,
        highImpactEventCount: periodEvents.filter(
            (event) => event.source === CALENDAR_EVENT_SOURCE_IDS.economic && event.impact === 'high',
        ).length,
        totalEventCount: periodEvents.length,
    };
};
